import React from 'react';

const FAQSection = ({ title = 'Frequently Asked Questions', faqs = [] }) => {
  if (!faqs.length) return null;

  return (
    <section className="py-14 px-4">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-playfair font-bold text-gray-800 mb-8">
          {title}
        </h2>
        <div className="space-y-4">
          {faqs.map((faq) => (
            <details key={faq.q} className="card">
              <summary className="cursor-pointer text-lg font-semibold text-gray-800">
                {faq.q}
              </summary>
              <p className="mt-3 text-gray-700 leading-relaxed">{faq.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
